import { FacetNames } from '../types';

export function getAlgoliaFacetName(facet: string): string {
  const lowerCaseFacet = facet.toLocaleLowerCase();

  if (lowerCaseFacet.length === 0) return '';

  if (FacetNames.SIZE.includes(lowerCaseFacet)) return FacetNames.SIZE;

  if (FacetNames.FIT.includes(lowerCaseFacet)) return FacetNames.FIT;

  if (FacetNames.HEEL_HEIGHT.includes(lowerCaseFacet)) return FacetNames.HEEL_HEIGHT;

  if (FacetNames.COLOR.includes(lowerCaseFacet)) return FacetNames.COLOR;

  if (FacetNames.GENDER.includes(lowerCaseFacet)) return FacetNames.GENDER;

  if (FacetNames.PRODUCT.includes(lowerCaseFacet)) return FacetNames.PRODUCT;

  if (FacetNames.STYLE.includes(lowerCaseFacet)) return FacetNames.STYLE;

  if (FacetNames.FASTENING.includes(lowerCaseFacet)) return FacetNames.FASTENING;

  if (FacetNames.TECHNOLOGY.includes(lowerCaseFacet)) return FacetNames.TECHNOLOGY;

  if (FacetNames.TOP_RATED.includes(lowerCaseFacet)) return FacetNames.TOP_RATED;

  if (FacetNames.BRAND.includes(lowerCaseFacet)) return FacetNames.BRAND;

  if (FacetNames.MATERIAL.includes(lowerCaseFacet)) return FacetNames.MATERIAL;

  if (FacetNames.PRICE.includes(lowerCaseFacet)) return FacetNames.PRICE;

  return '';
}
